import { queryAxis, queryAxisLabel } from "./axis.js";
import { isLayerWithQuery } from './layer.js';
import { propChannels } from './mark.js';
import { makeFilterFunction } from './utility.js';
import { queryTitleItem } from './title.js';

export async function LockTransformation(role, spec, original, specifier, action, option) {
  if (spec.globalLock === undefined) {
    spec.globalLock = {}
  }
  if (role === "data") {
    // {data / lock / data: true|false}
    if (option?.data === true) spec.globalLock.data = true;
    else if (option?.data === false) spec.globalLock.data = false;
  } else if (["transform", "data.transform"].includes(role)) {
    // {transform / lock / transform: true|false}
    if (option?.transform === true) spec.globalLock.transform = true;
    else if (option?.transform === false) spec.globalLock.transform = false;
  } else if (role === "view") {
    // layout: composition and transpose
    if (spec.layout.lock === undefined) {
      spec.layout.lock = {};
    }
    if (option?.transpose === true) spec.layout.lock.transpose = true;
    else if (option?.transpose === false) spec.layout.lock.transpose = false;
    if (option?.composition === true) spec.layout.lock.composition = true;
    else if (option?.composition === false) spec.layout.lock.composition = false;
    if (option?.nColumns === true) spec.layout.lock.nColumns = true;
    else if (option?.nColumns === false) spec.layout.lock.nColumns = false;
  } else if (["view.row", "row"].includes(role)) {
    // layout: row
    spec.layout?.row?.forEach((rc, i) => {
      let flag = true;
      if (specifier.field && specifier.field !== rc.field) flag = false;
      if (specifier.index !== undefined && specifier.index != i) flag = false;
      if (flag) {
        if (option?.encoding === true) rc.lock = true;
        else if (option?.encoding === false) rc.lock = false;
      }
    });
  } else if (["view.column", "column"].includes(role)) {
    // layout: column
    spec.layout?.column?.forEach((rc, i) => {
      let flag = true;
      if (specifier.field && specifier.field !== rc.field) flag = false;
      if (specifier.index !== undefined && specifier.index != i) flag = false;
      if (flag) {
        if (option?.encoding === true) rc.lock = true;
        else if (option?.encoding === false) rc.lock = false;
      }
    });
  } else if (["view.axis", "axis"].includes(role) || ["view.hAxis", "hAxis"].includes(role) || ["view.vAxis", "vAxis"].includes(role)) {
    // axis design
    let axisElements = queryAxis(role, spec, original, specifier, action, option);
    axisElements.forEach((axisItem) => {
      if (axisItem == "hAxis") {
        if (spec.layout.haxis === undefined) spec.layout.haxis = {};
        if (option?.axis === true || option?.hAxis === true) spec.layout.haxis.lock = true;
        else if (option?.axis === false || option?.hAxis === false) spec.layout.haxis.lock = false;
      }
      else if (axisItem == "vAxis") {
        if (spec.layout.vaxis === undefined) spec.layout.vaxis = {};
        if (option?.axis === true || option?.vAxis === true) spec.layout.vaxis.lock = true;
        else if (option?.axis === false || option?.vAxis === false) spec.layout.vaxis.lock = false;
      }
    })
  } else if (["axis.label", "view.axis.label", "text.axis.label"].includes(role) || ["vAxis.label", "view.vAxis.label", "text.vAxis.label"].includes(role) || ["hAxis.label", "view.hAxis.label", "text.hAxis.label"].includes(role)) {
    // axis labels
    let fieldname;
    if (option?.label !== undefined) {
      let axisElements = queryAxisLabel(role, spec, original, specifier, action, option);
      axisElements.forEach(axisItem => {
        if (specifier.field) fieldname = specifier.field;
        else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
        else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
        else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
        else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
        if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
        spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              if (option.label === true) textItem.lock = true;
              else if (option.label === false) textItem.lock = false;
            }
          });
        });
      });
    }
  } else if (["layer.mark", "mark"].includes(role)) {
    if (option) {
      console.log(spec.layer.length, spec.name);
      spec.layer.forEach((layerItem, li) => {
        //todo: channel/encoded field-wise filtering
        let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.index, specifier.id);
        if (!flag) return;
        let encoded_fields = Object.keys(layerItem.mark).map(d => d.field).filter(d => d !== undefined);
        let encoded_channels = Object.keys(layerItem.mark).filter(d => propChannels.includes(d));
        if (specifier.mark !== undefined && specifier.mark !== layerItem.mark.type) flag = false;
        if (specifier.field !== undefined && !encoded_fields.includes(specifier.field)) flag = false;
        if (specifier.channel !== undefined) {
          if (specifier.channel.constructor.name === "String" && !encoded_channels.includes(specifier.channel)) flag = false;
          else if (specifier.channel.constructor.name === "Array") {
            if (specifier.channel.field !== undefined && !specifier.channel.every(ch => encoded_channels.includes(ch))) flag = false;
          }
        }
        propChannels.forEach(ch => {
          if (specifier[ch] !== undefined) {
            if (specifier[ch].field !== undefined && specifier[ch].field !== layerItem.mark[ch]?.field) flag = false;
            else if (specifier[ch].value !== undefined && specifier[ch].value !== layerItem.mark[ch]?.value) flag = false;
            // todo: expand
          }
        });
        if (flag) {
          Object.keys(option).forEach((key) => {
            if (key === "markType") {
              if (option.markType === true) layerItem.mark.lock = true;
              else if (option.markType === false) layerItem.mark.lock = false;
            } else if (propChannels.includes(key) && layerItem.mark[key] !== undefined) {
              if (option[key] === true) layerItem.mark[key].lock = true;
              else if (option[key] === false) layerItem.mark[key].lock = false;
            }
          });
        }
      });
    }
  } else if (["layer.mark.label", "mark.label", "text.mark"].includes(role)) {
    if (option?.label !== undefined) {
      spec.layer.forEach((layerItem, lindex) => {
        // layer query
        let toAdd = [];
        let flag = true;
        if ((specifier.mark !== undefined && specifier.mark !== layerItem.mark?.type)) flag = false;
        if (specifier.layer?.id !== undefined && specifier.layer?.id !== layerItem.name) flag = false;
        if (specifier.layer?.index !== undefined && specifier.layer?.index !== lindex) flag = false;

        if (flag) {
          let markTextIndex = 0;
          layerItem.text?.filter(d => d.type === "on-mark")?.forEach((textItem, ti) => {
            if (specifier.index !== undefined && markTextIndex !== specifier.index) return;
            if (specifier.field !== undefined && textItem.field !== specifier.field) return;
            markTextIndex++;
            if (option.label === true) textItem.lock = true;
            else if (option.label === false) textItem.lock = false;
          });
        }
      });
    }
  } else if (["mark.tooltip", "tooltip", "interaction.tooltip"].includes(role)) {
    // tooltip
    if (option?.tooltip !== undefined || option?.position !== undefined) {
      spec.layer.forEach((layerItem, li) => {
        let flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.layer.index, specifier.layer.id);
        if (flag && layerItem.tooltip !== undefined) { // more query (todo)
          if (option.tooltip === true) layerItem.tooltip.lock = true;
          else if (option.tooltip === false) layerItem.tooltip.lock = false;

          if (option.position === true) layerItem.tooltip.positionLock = true;
          else if (option.position === false) layerItem.tooltip.positionLock = false;
        }
      });
    }
  } else if (["layer.legend", "legend"].includes(role)) {
    // legend design & position
    if (option?.legend !== undefined || option?.position !== undefined) {
      spec.layer?.forEach((layerItem, li) => {
        if (specifier.layer) {
          let flag = isLayerWithQuery(layerItem, li, specifier.layer.mark, specifier.layer.index, specifier.layer.id);
          if (flag) { // further data query
            if (specifier.data !== undefined) {
              let fstr = toFilterString(specifier.data)
              if (layerItem.transform === undefined) flag = false;
              else {
                if (layerItem.transform.filter(transform => {
                  return transform.includes(fstr)
                }).length == 0) flag = false;
              }
            }
          }
          if (!flag) return false;
        }
        layerItem.text.forEach((textItem) => {
          if (textItem.type === "legend") {
            let flag = true;
            if (specifier.field && textItem.field !== specifier.field) flag = false;
            else if (specifier.aggregate && textItem.aggregate !== specifier.aggregate) flag = false;
            else if (specifier.channel) {
              if (specifier.channel !== textItem.channel) flag = false;
              else if (textItem.field !== layerItem.mark?.[specifier.channel]?.field) flag = false;
            }
            if (flag) {
              if (option.legend === true) textItem.lock = true;
              else if (option.legend === false) textItem.lock = false;
              // !!
              if (option.position === true) textItem.positionLock = true;
              else if (option.position === false) textItem.positionLock = false;
            }
          }
        });
      });
    }
  } else if (["annotation", "text.annotation", "view.annotation"].includes(role)) {
    // annotation
    if (option?.annotation !== undefined || option?.position !== undefined) {
      let fcnt = 0;
      let aCount = 0;
      spec.annotation?.items.forEach((annoItem, ai) => {
        let flag = (annoItem.type === "text");
        // filtering: index, text...
        if (flag) {
          if (specifier.id !== undefined && annoItem.name !== specifier.id) flag = false;
          if (specifier.index !== undefined && aCount !== specifier.index) flag = false;
          if (specifier.text !== undefined) {
            if (specifier.text.constructor.name !== "Array") {
              specifier.text = [specifier.text]
            }
            specifier.text.forEach(textQuery => {
              if (textQuery.items !== undefined) {
                flag = textQuery.items.map((titem, tii) => {
                  return makeFilterFunction(titem, true)(annoItem.text[tii]?.text)
                }).every(d => d);
              } else {
                flag = makeFilterFunction(specifier.text, true)(annoItem?.text?.map(d => d.text).join(" "))
              }
            });
          }
        }
        if (flag) {
          fcnt += 1;
          if (option.annotation === true) annoItem.lock = true;
          else if (option.annotation === false) annoItem.lock = false;
          // !!
          if (option.position === true) annoItem.positionLock = true;
          else if (option.position === false) annoItem.positionLock = false;
        }
      });
      aCount += 1;
    }
  } else if (["emphasis", "view.emphasis"].includes(role)) {
    if (option?.emphasis !== undefined || option?.position !== undefined) {
      let fcnt = 0;
      spec.emphasis.items.forEach((emphItem, ai) => {
        let flag = true;
        // filtering: index, text...
        if (flag) {
          if (specifier.index !== undefined && ai !== specifier.index) flag = false;
          if (specifier["id"] !== undefined) {
            if (specifier["id"].constructor.name === "Array") flag = specifier["id"].includes(emphItem.name);
            else flag = (specifier["id"] == emphItem.name);
          }
        }
        if (flag) {
          fcnt += 1;
          if (option.emphasis === true) emphItem.lock = true;
          else if (option.emphasis === false) emphItem.lock = false;
          // !!
          if (option.position === true) emphItem.positionLock = true;
          else if (option.position === false) emphItem.positionLock = false;
        }
      });
    }
  } else if (["title", "text.title", "view.title"].includes(role)) {
    if (option?.title !== undefined) {
      spec.title?.items?.forEach((titleItem, ai) => {
        let flag = queryTitleItem(titleItem, ai, specifier);
        if (flag) {
          if (option.title === true) titleItem.lock = true;
          else if (option.title === false) titleItem.lock = false;
        }
      });
    }
  } else if (["interaction", "view.interaction"].includes(role)) {
    if (spec.interaction === undefined) spec.interaction = { lock: {} };
    else if (spec.interaction.lock === undefined) spec.interaction.lock = {};
    if (specifier.interaction === "context" && option?.context !== undefined) {
      if (option.context === true) spec.interaction.lock.context = true;
      else if (option.context === false) spec.interaction.lock.context = false;
    } else if (specifier.interaction === "zoompan" && option?.zoompan !== undefined) {
      if (option.zoompan === true) spec.interaction.lock.zoompan = true;
      else if (option.zoompan === false) spec.interaction.lock.zoompan = false;
    }
    if (Object.keys(spec.interaction).length == 1 && Object.keys(spec.interaction.lock).length == 0) {
      delete spec.interaction;
    }
  } else if (["view.facet.title", "facet.title", "view.facet.text", "facet.text", "view.facet.label", "facet.label"].includes(role)) {
    //  todo
    if (!spec.layout?.lock) spec.layout.lock = {};
    if (option.label !== undefined) spec.layout.lock["header"] = option.label;
  }
  return spec;
}